import { EASY_MODE_UPLOAD_STATUS } from '../constants/easyModeDocuments';

export const buildUploadStateByUploadId = ({ fileUpload }) => {
  const {
    uploadQueue = [],
    activeUploads = {},
    completedUploads = [],
    failedUploads = []
  } = fileUpload ?? {};

  const stateByUploadId = {};

  completedUploads.forEach(({ id }) => {
    stateByUploadId[id] = { status: EASY_MODE_UPLOAD_STATUS.UPLOADED, progress: 100 };
  });

  uploadQueue.forEach(({ id }) => {
    stateByUploadId[id] = { status: EASY_MODE_UPLOAD_STATUS.PENDING, progress: 0 };
  });

  Object.entries(activeUploads).forEach(([uploadId, { progress = 0 }]) => {
    stateByUploadId[uploadId] = { status: EASY_MODE_UPLOAD_STATUS.UPLOADING, progress };
  });

  failedUploads.forEach(({ id }) => {
    stateByUploadId[id] = { status: EASY_MODE_UPLOAD_STATUS.FAILED, progress: 0 };
  });

  return stateByUploadId;
};
